import jsonData from '../signals/jsonData';
import appState from '../signals/appState';

const setLanguage = (languageCode) => {
	if (!languageCode) return;

	fetch(`./data-${languageCode}.json`)
		.then((response) => response.json())
		.then((data) => {
			console.log('language data', data);
			const localData = JSON.parse(localStorage.getItem('data'));

			jsonData.value = {
				...jsonData.value,
				currentLanguage: data.currentLanguage,
				basicInfo: {
					...jsonData.value.basicInfo,
					name: data.basicInfo.name,
					intro: data.basicInfo.intro,
					link: data.basicInfo.link,
				},
				floorInfo: jsonData.value.floorInfo.map((floor, index) => {
					return {
						...floor,
						name: data.floorInfo[index]?.name,
						map: data.floorInfo[index]?.map,
						sections: floor.sections?.map((section, sectionIndex) => {
							return {
								...section,
								name: data.floorInfo[index]?.sections[sectionIndex]?.name,
							};
						}),
					};
				}),
				exhibitorInfo: data.exhibitorInfo.map((exhibitor) => {
					const products = data.productInfo.filter((product) => product['攤位號碼'] === exhibitor['攤位號碼']);

					let favourite = false;

					if (localData && localData.favouriteExhibitors) {
						favourite = localData.favouriteExhibitors.includes(exhibitor['攤位號碼']);
					}

					return {
						...exhibitor,
						products,
						favourite,
					};
				}),
				productInfo: data.productInfo,
				navigationInfo: data.navigationInfo,
			};

			appState.value = {
				...appState.value,
				loading: false,
			};
		})
		.catch(() => {
			console.log('匯入語言資料錯誤');
		});
};

export default setLanguage;
